import React, { useMemo, useEffect } from "react";
import useCustomFecthQuery from "../../../../Hooks/useCustomFecthQuery";
import Divider from "./Divider";
import "./sponsorsMarquee.scss";

const Sponsors = ({ token, eventID }) => {
  const {
    data: getMySponsors,
    isLoading: isLoadingSponsors,
  } = useCustomFecthQuery(
    ["mySponsors", eventID],
    `${process.env.REACT_APP_API}sponsors/event/${eventID}`,
    token,
    { enabled: !!eventID }
  );

  const {
    data: getMyBooths,
    isLoading: isLoadingBooths,
  } = useCustomFecthQuery(
    ["myBooths", eventID],
    `${process.env.REACT_APP_API}booths/event/${eventID}`,
    token,
    { enabled: !!eventID }
  );

  // Prepare data
  const sponsorsList = Array.isArray(getMySponsors?.data) ? getMySponsors.data : [];
  const boothsList = Array.isArray(getMyBooths?.data) ? getMyBooths.data : [];
  const allSponsors = [...sponsorsList, ...boothsList];

  // Duplicate for infinite scroll
  const marqueeContent = useMemo(() => {
    if (allSponsors.length === 0) return [];
    return [...allSponsors, ...allSponsors]; 
  }, [allSponsors]);

  if (isLoadingSponsors || isLoadingBooths) return null;

  return (
    <section id="sponsors" className="sponsors-section">
      <h1 className="sponsors-title">Official Sponsors</h1>
      <Divider />
      
      {allSponsors.length > 0 ? (
        <div className="marquee-container">
          {/* Fade Gradients - Reduced opacity on mobile in SCSS */}
          <div className="marquee-fade-left"></div>
          <div className="marquee-fade-right"></div>
          
          <div className="marquee-track">
            {marqueeContent.map((sponsor, index) => (
              <div key={`${sponsor?.id || index}-${index}`} className="sponsor-card">
                <div className="sponsor-logo-wrapper">
                  <img
                    src={sponsor?.logo}
                    alt={sponsor?.name || "Sponsor"}
                    className="sponsor-logo"
                    onError={(e) => e.target.style.display = 'none'} // Hide if broken
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default Sponsors;